import { useInfiniteQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContactInstruments } from 'services/ContactService'
import { ContactPaymentInstrumentsResponse, InstrumentType } from 'types/contacts'

interface ContactInstrumentsInfiniteQueryProps {
  searchTerm?: string
  paymentMethod?: InstrumentType
  currency?: string
  enabled?: boolean
  size?: number
}

export const useContactInstrumentsInfiniteQuery = ({
  searchTerm = '',
  paymentMethod,
  currency,
  enabled = true,
  size = 10,
}: ContactInstrumentsInfiniteQueryProps) => {
  return useInfiniteQuery({
    enabled,
    queryKey: reactQueryKeys.contactPaymentInstruments(searchTerm, paymentMethod, currency),
    queryFn: ({ pageParam = 0 }) =>
      getContactInstruments({
        searchTerm,
        size,
        page: pageParam,
        sort: '',
        paymentMethod,
        currency,
      }),
    getNextPageParam: (lastPage: ContactPaymentInstrumentsResponse) => {
      return lastPage?.pageable?.pageNumber + 1 < lastPage?.totalPages
        ? lastPage?.pageable.pageNumber + 1
        : undefined
    },
    initialPageParam: 0,
    select: data => {
      const contactInstruments = data?.pages?.flatMap(page => page?.content)
      return contactInstruments
    },
  })
}
